export const TICK = 'TICK'

export const tick = (): Object => {
  return {
    type: TICK,
    data: new Date().getTime()
  }
}